import { autoRegisterFeature } from '@store/features/factory';

import { jotSupportFeature } from './store/feature';

autoRegisterFeature(jotSupportFeature);

export { JotSupportContainer } from './components/JotSupportContainer';
export { JotSupportWithPulse } from './pulse/JotSupportWithPulse';
export { useCheckSupportRequest, useSubmitSupportRequest } from './store';
